import React from 'react';
// import { useTranslation } from 'react-i18next'; // No se usa actualmente

interface StorageErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  error: string;
  details?: any;
  onRetry?: () => void;
}

const StorageErrorModal: React.FC<StorageErrorModalProps> = ({
  isOpen,
  onClose,
  error,
  details,
  onRetry
}) => {
  // const { t } = useTranslation(); // No se usa actualmente

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-red-600">Error de Almacenamiento</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-red-600 text-2xl font-bold"
          >
            ×
          </button>
        </div>

        <div className="space-y-4">
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <h3 className="text-lg font-semibold text-red-800 mb-2">Descripción del Error:</h3>
            <p className="text-red-700">{error}</p>
          </div>

          {details && (
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Detalles Técnicos:</h3>
              <pre className="text-sm text-gray-700 bg-white p-3 rounded border overflow-x-auto">
                {JSON.stringify(details, null, 2)}
              </pre>
            </div>
          )}

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h3 className="text-lg font-semibold text-blue-800 mb-2">Posibles Soluciones:</h3>
            <ul className="text-blue-700 space-y-2">
              <li>• Verifica que estés conectado a internet</li>
              <li>• Intenta cerrar sesión y volver a iniciar sesión</li>
              <li>• Limpia el caché del navegador</li>
              <li>• Verifica que el archivo no esté corrupto</li>
              <li>• Asegúrate de que el archivo no exceda 5MB</li>
              <li>• Contacta al administrador si el problema persiste</li>
            </ul>
          </div>
        </div>

        <div className="flex gap-3 mt-6">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-lg font-medium transition-colors duration-200"
          >
            Cerrar
          </button>
          {onRetry && (
            <button
              onClick={onRetry}
              className="flex-1 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-medium transition-colors duration-200"
            >
              Reintentar
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default StorageErrorModal; 